import { NgModule, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule, ActivatedRouteSnapshot, } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { SiteLayoutComponent } from './layout/site-layout/site-layout.component';
import { HomeComponent } from './home/home.component';
import { ProductDescriptionComponent } from './product-description/product-description.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { ProductImageComponent } from './product-image/product-image.component';
import { SiteHeaderComponent } from './layout/site-header/site-header.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { CategoryComponent } from './category/category.component';
import { SiteFooterComponent } from './layout/site-footer/site-footer.component';

import { FeedbackPageComponent } from './feedback-page/feedback-page.component';

import { AppHeaderComponent } from './layout/app-header/app-header.component';
import { AppLayoutComponent } from './layout/app-layout/app-layout.component';
import { ProductSearchComponent } from './product-search/product-search.component';
import { CustomDesignComponent } from './custom-design/custom-design.component';
import { from } from 'rxjs';
import { TermsConditionComponent } from './terms-condition/terms-condition.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
//import { CommentComponent } from './comment/comment.component';



const routes: Routes = [

  {
    path: '',
    component: SiteLayoutComponent,
    children: [

      { path: '', component: HomeComponent, pathMatch: 'full' },
      { path: 'login', component: LoginComponent },
      { path: 'signup', component: SignupComponent },
      { path: 'feedbackpage', component: FeedbackPageComponent },
      { path: 'home', component: HomeComponent },
      { path: 'siteHeader', component: SiteHeaderComponent },
      { path: 'siteFooter', component: SiteFooterComponent },
      {
        path: 'product/:id', component: ProductDescriptionComponent,
      },
      { path: 'forgotPassword', component: ForgotPasswordComponent },
      { path: 'productImage' , component: ProductImageComponent},
      { path: 'resetPassword', component: ResetPasswordComponent },
      { path: 'category/:id/:categoryName', component: CategoryComponent },
      { path: 'productSearch/:id/:searchKeyword', component: ProductSearchComponent },
      { path: 'custom-design', component:CustomDesignComponent},
      { path: 'contactUs/:feedbackType', component: ContactUsComponent },
      { path: 'termsCondition', component: TermsConditionComponent },
      { path: 'privacyPolicy', component: PrivacyPolicyComponent }

    ]
  },
  {
    path: '',
    component: AppLayoutComponent,
    children: [
      { path: 'aboutus', component: AboutUsComponent, pathMatch: 'full' },
    ]
  },
  {
    path: 'product/:id', component: ProductDescriptionComponent,
  },

];

@NgModule({

  imports: [
    CommonModule,
    RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
